/**
 * RgSection — Roomgrid card section for the test pages.
 *
 * One elevated card holds the whole form; each logical block is a section
 * with an uppercase micro header, 14/18 padding and a hairline separator
 * (mirrors the "Test Email" mock from the design handoff).
 */

import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

export interface RgSectionProps {
  label: string;
  children: React.ReactNode;
  /** Skip the bottom hairline (last section of the card). */
  last?: boolean;
}

export const RgSection: React.FC<RgSectionProps> = ({
  label,
  children,
  last = false,
}) => {
  const theme = useTheme();
  const rg = theme.custom.rg;
  return (
    <Box
      sx={{
        p: "14px 18px",
        borderBottom: last ? "none" : `1px solid ${rg.border}`,
      }}
    >
      <Typography
        sx={{
          fontSize: "10.5px",
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          fontWeight: 600,
          color: rg.text3,
          mb: "10px",
        }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  );
};

export default RgSection;
